import { Botao, Selo } from "@plantus/ui";
import type { Coluna } from "@plantus/ui";
import type { Recipiente } from "@plantus/api-client";

import { ROTULO_DO_ESTADO, TOM_DO_ESTADO } from "./estadoDoRecipiente";

/**
 * As colunas do parque de recipientes.
 *
 * <p>Saíram de dentro de `PaginaRecipientes.tsx` no recorte do ADR-0013 §1/§2 —
 * o arquivo media 440 linhas contra um teto de 300, e o destino registrado no
 * ADR é <i>"parque · dossiê do recipiente"</i>: este é o parque. Nenhuma
 * definição mudou de conteúdo. Mesmo recorte, mesmo formato e mesmo motivo que
 * `PaginaLotesColunas.tsx` e `PaginaFornecedoresColunas.tsx`.
 *
 * <p>⚠️ Nenhuma coluna de EMPRESA aqui, e é a decisão do ADR-0012 item 2: o
 * recipiente não pertence a um CNPJ. Quem diz de quem era o material é a
 * ocupação, e ela mora no dossiê.
 */
export function colunas(selecionar: (id: string) => void): Coluna<Recipiente>[] {
  return [
    { chave: "codigo", rotulo: "Código", principal: true, mono: true, conteudo: (r) => r.codigo },
    {
      chave: "tipo",
      rotulo: "Tipo",
      // Travessão só onde a ausência é legítima e temporária: o dossiê é
      // preenchido depois do recebimento, de propósito.
      conteudo: (r) => r.palavraDoTipo ?? "—",
    },
    { chave: "construcao", rotulo: "Construção", conteudo: (r) => r.construcao ?? "—" },
    {
      chave: "capacidade",
      rotulo: "Capacidade (L)",
      numerica: true,
      conteudo: (r) => r.capacidadeNominalEmLitros ?? "—",
    },
    {
      chave: "estado",
      rotulo: "Estado",
      conteudo: (r) => (
        <Selo ativo={TOM_DO_ESTADO[r.estado]}>{ROTULO_DO_ESTADO[r.estado]}</Selo>
      ),
    },
    {
      chave: "ocupado",
      rotulo: "Conteúdo",
      // DERIVADO, e a tela diz isso do jeito que a operação lê: "tem
      // material dentro" ou "vazio". Não é coluna do banco — gravá-lo
      // seria a segunda verdade que o ADR-0012 rejeita.
      conteudo: (r) => (r.ocupado ? "Ocupado" : "Vazio"),
    },
    {
      chave: "acao",
      rotulo: "Ações",
      rotuloOculto: true,
      conteudo: (r) => (
        <Botao aparencia="texto" onClick={() => selecionar(r.id)}>
          Abrir
        </Botao>
      ),
    },
  ];
}
